/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteBookmark.defs.js'
export * as $defs from './deleteBookmark.defs.js'
